import { createStore, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import reducers from "../reducer";
import { initialStore } from "./initialStore";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

// normal store
const store = createStore(reducers, initialStore, applyMiddleware(thunk));

// const persistConfig = {
//     key:'root',
//     storage
// }

// const persistedReducer = persistReducer(persistConfig, reducers);

// const store = createStore(persistedReducer, initialStore, applyMiddleware(thunk));

// const persistor = persistStore(store);

// export {store,persistor};
export default store;

